var React = require('react');

function MailB (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 1H19C20.1 1 21 1.8621 21 2.91577V14.4104C21 15.4641 20.1 16.3262 19 16.3262H3C1.9 16.3262 1 15.4641 1 14.4104V2.91577C1 1.8621 1.9 1 3 1Z","stroke":"#1E3774","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M21 2.91574L11 9.62101L1 2.91574","stroke":"#1E3774","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

MailB.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18","fill":"none"};

module.exports = MailB;

MailB.default = MailB;
